import { atom } from 'jotai';
import { UploadTask_Base } from '~/common/typescript/models/UploadTask';

export const show_UploadTask_UpdatePanel_Atom = atom<boolean>(false);

export const editingUploadTaskAtom = atom<UploadTask_Base | null>(null);

export const showPanel = (setIsOpen: (value: boolean) => void) => {
  setIsOpen(true);
};

export const hidePanel = (setIsOpen: (value: boolean) => void) => {
  setIsOpen(false);
};
